export enum IRoomsActionTypes {
  FETCH_ROOMS_REQUEST = "FETCH_ROOMS_REQUEST",
  FETCH_ROOMS_SUCCESS = "FETCH_ROOMS_SUCCESS",
  FETCH_ROOMS_FAILURE = "FETCH_ROOMS_FAILURE",
}

export interface IRoomsListResponse {
  data: IRoomItem[];
  success?: boolean;
  is_admin?: boolean;
}

export interface IRoomItem {
  id: string;
  room_name: string;
  opened_threads?: number;
  unread_count?: number;
  created_by?: string;
}

export type IRoomsActionCreator = {
  type: IRoomsActionTypes | string;
  payload?: any;
};